import { isMobile, isTablet } from 'react-device-detect';
import { v4 as uuid } from 'uuid';
import { EstacionBuscar, EstacionGuardar } from '../../configuracion/apiUrls';
import { mostraAlerta, mostraAlertaError } from '../alerts/sweetAlert';
import { AxiosPrivado } from '../axios/Axios';

export const IdentificarEstacion = async (usuario = null) => {
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const dispositivo = isMobile ? 'Móvil' : isTablet ? 'Tablet' : 'PC';
    var id = localStorage.getItem('device-idAressa');
    var tokene = localStorage.getItem('tokeneAressa');
    if (!id) {
        id = uuid();
        try {
            const response = await AxiosPrivado.post(EstacionGuardar, {
                nombre: id, descripcion: userAgent, lenguaje: language, dispositivo, usuarioId: usuario
            })
            const token = response.data.token;
            if (!token) {
                mostraAlertaError("Error al procesar los datos de la estación")
            }
            else {
                localStorage.setItem('device-idAressa', id);
                localStorage.setItem('tokeneAressa', token);
                tokene = token;
                mostraAlerta("Nuevo dispositivo registrado como estación");
            }

        } catch (error) {
            mostraAlertaError("Error al guardar datos de la estación");
        }
        /*if(mostraAlertaPregunta("Desea registrar este dispositivo como caja?")){
            try {
                const response = await AxiosPrivado.post(GuardarCaja, { 
                nombre: id, estado: 'CE', descripcion: userAgent, lenguaje: language, dispositivo
            })
            } catch (error) {
                mostraAlertaError("Error al guardar datos de caja");
            }
            
        }*/
    }
    else {
        try {
            const response1 = await AxiosPrivado.get(EstacionBuscar + id)
            const estacion = response1.data;
            if (!estacion) {
                const response = await AxiosPrivado.post(EstacionGuardar, {
                    nombre: id, descripcion: userAgent, lenguaje: language, dispositivo, usuarioId: usuario
                })
                const token = response.data.token;
                if (!token) {
                    mostraAlertaError("Error al procesar los datos de la estación")
                }
                else {
                    localStorage.setItem('device-idAressa', id);
                    localStorage.setItem('tokeneAressa', token);
                    tokene = token;
                    mostraAlerta("Nuevo dispositivo registrado como estación");
                }
            }
        } catch (error) {
            mostraAlertaError("Error al guardar datos de la estación");
        }
    }
    const datosEstacion = {
        userAgent,
        language,
        dispositivo,
        id: id,
        token: tokene
    }
    return datosEstacion;
}